import moment from "moment";

export default{
    data() {
        return {
            errors: [],
            formSubmitted: false,
            valid: false,
            form: {},
            errors: {}
        }
    },
    methods: {
        setForm(employee) {
            this.clearForm();

            this.form = {
                id: employee.id ? employee.id : 0,
                name: employee.name ? employee.name : '',
                rfc: employee.rfc ? employee.rfc : '',
                curp: employee.curp ? employee.curp : '',
                nss: employee.nss ? employee.nss : '',
                address: employee.address ? employee.address : '',
                zipcode: employee.zipcode ? employee.zipcode : '',
                employee_position_id: employee.employee_position_id ? employee.employee_position_id : 0,
                contract_date: employee.contract_date ? moment(employee.contract_date, "YYYY-MM-DD").toDate() : moment().toDate(),
                initial_date: employee.initial_date ? moment(employee.initial_date, "YYYY-MM-DD").toDate() : moment().toDate(),
                final_date: employee.final_date ? moment(employee.final_date, "YYYY-MM-DD").toDate() : moment().toDate(),
                employer_id: employee.employer_id ? employee.employer_id : 0,
                employee_boss_id: employee.employee_boss_id ? employee.employee_boss_id : 0,
                employee_collaborator_id: employee.employee_collaborator_id ? employee.employee_collaborator_id : 0,
                employee_number: employee.employee_number ? employee.employee_number : '',
                rest_day_1: employee.rest_day_1 == 0 ? true : false,
                rest_day_2: employee.rest_day_2 == 0 ? true : false,
                rest_day_3: employee.rest_day_3 == 0 ? true : false,
                rest_day_4: employee.rest_day_4 == 0 ? true : false,
                rest_day_5: employee.rest_day_5 == 0 ? true : false,
                rest_day_6: employee.rest_day_6 == 0 ? true : false,
                rest_day_7: employee.rest_day_7 == 0 ? true : false,
                daily_salary: employee.daily_salary ? employee.daily_salary : '',
                integral_daily_salary: employee.integral_daily_salary ? employee.integral_daily_salary : '',
                integration_factor: employee.integration_factor ? employee.integration_factor : '',
                final_wage: employee.final_wage ? employee.final_wage : '',
                fonacot: employee.fonacot > 0 ? employee.fonacot : '0.00',
                infonavit: employee.infonavit > 0 ? employee.infonavit : '0.00',
                bono_amount: employee.bono_amount ? employee.bono_amount : '0.00',
                bono_frecuency: employee.bono_frecuency ? employee.bono_frecuency : '',
                bank: employee.bank ? employee.bank : '',
                clabe: employee.clabe ? employee.clabe : '',
                email: employee.email ? employee.email : '',
                phone: employee.phone ? employee.phone : '',
                birthdate: employee.birthdate ? moment(employee.birthdate, "YYYY-MM-DD").toDate() : moment().toDate(),
                contact_name: employee.contact_name ? employee.contact_name : '',
                contact_phone: employee.contact_phone ? employee.contact_phone : '',
                employee_collaborator: employee.employee_collaborator ? employee.employee_collaborator : '',
                employee_boss: employee.employee_boss ? employee.employee_boss : '',
                is_active: employee.is_active ? employee.is_active : 1,
                observations: employee.observations ? employee.observations : '',
                start_hour: employee.start_hour ? employee.start_hour : '08:00',
                end_hour: employee.end_hour ? employee.end_hour : '16:00',
                net_fiscal: employee.net_fiscal ? employee.net_fiscal.toFixed(2) : '0.00',
                net_complementary: employee.net_complementary ? employee.net_complementary.toFixed(2) : '0.00',
                net_final: employee.net_final ? employee.net_final.toFixed(2) : '0.00',
                isr: employee.isr ? employee.isr : '0.00',
                imss: employee.imss ? employee.imss : '0.00',
                infonavit: employee.infonavit ? employee.infonavit : '0.00',
                fonacot: employee.fonacot ? employee.fonacot : '0.00',
                salary: employee.salary ? employee.salary : '0.00',
                email: employee.email ? employee.email : '',
                employee_url: employee.employee_url ? employee.employee_url : '',
                total_work_days: employee.total_work_days ? employee.total_work_days : '15',
                work_age: 0
            }

            const today = moment();
            const initial = moment(employee.initial_date, "YYYY-MM-DD");
            const years = today.diff(initial, 'years');

            let vacations = 12;
            switch(years){
                case 0: vacations = 12; break;
                case 1: vacations = 14; break;
                case 2: vacations = 16; break;
                case 3: vacations = 18; break;
                case 4: vacations = 20; break;
                case 5: case 6: case 7: case 8: case 9: vacations = 22; break;
                case 10: case 11: case 12: case 13: case 14: vacations = 24; break;
                case 15: case 16: case 17: case 18: case 19: vacations = 26; break;
                case 20: case 21: case 22: case 23: case 24: vacations = 28; break;
                case 25: case 26: case 27: case 28: case 29: vacations = 30; break;
                case 30: case 31: case 32: case 33: case 34: vacations = 32; break;
            }

            const factor = 1 + (15 / 365) + ((vacations * 0.25) / 365);

            this.form.work_age = years + 1;
            this.form.daily_salary = employee.daily_salary;
            this.form.integration_factor = factor;
            this.form.integral_daily_salary = this.form.daily_salary * this.form.integration_factor;
        },
        clearForm() {
            this.form = {
                id: 0,
                name: '',
                rfc: '',
                curp: '',
                nss: '',
                address: '',
                zipcode: '',
                address: '',
                employee_position_id: 0,
                contract_date: '',
                initial_date: '',
                final_date: '',
                employer_id: 0,
                employee_boss_id: 0,
                employee_number: '',
                total_work_days: 15,
                rest_day_1: true,
                rest_day_2: true,
                rest_day_3: true,
                rest_day_4: true,
                rest_day_5: true,
                rest_day_6: true,
                rest_day_7: false,
                daily_salary: '',
                integral_daily_salary: '',
                integration_factor: '',
                final_wage: '',
                fonacot: '0.00',
                infonavit: '0.00',
                bono_amount: '0.00',
                bono_frecuency: '',
                bank: '',
                clabe: '',
                email: '',
                phone: '',
                birthdate: '',
                contact_name: '',
                contact_phone: '',
                employee_collaborator_id: 0,
                is_active: 1,
                observations: '',
                start_hour: '08:00',
                end_hour: '16:00',
                net_fiscal: '0.00',
                email: ''
            };

            this.clearErrors();

            this.formSubmitted = false;
        },
        clearErrors() {
            this.errors = {
                name: false,
                rfc: false,
                curp: false,
                nss: false,
                employee_position_id: false,
                final_wage: false,
                bono_amount: false,
                employee_number: false,
                final_date: false,
                observations: false,
                zipcode: false,
                daily_salary: false,
                net_fiscal: false,
                email: false,
            };
        },
        storeEmployeeValidation() {
            this.formSubmitted = true;
            
            if(this.isStoreValid()){
                this.storeEmployee(this.form);
            }
        },
        isStoreValid(){
            this.valid = true;

            this.clearErrors();

            if(!(this.form.employer_id > 0)){
                this.errors.employer_id = "El patrón es obligatorio."
                this.valid = false;
            }
            
            if(this.form.name.length == 0){
                this.errors.name = "El nombre es obligatorio."
                this.valid = false;
            }

            if(this.form.employee_position_id == 0){
                this.errors.employee_position_id = "El puesto es obligatorio."
                this.valid = false;
            }
            
            return this.valid;
        },
        updateEmployeeGeneralValidation() {
            this.formSubmitted = true;
            
            if(this.isUpdateGeneralValid()){
                this.updateGeneralEmployee(this.form);
            }
        },

        updateEmployeeContractValidation() {
            this.formSubmitted = true;

            if(this.isUpdateContractValid()){
                this.updateContractEmployee(this.form);
            }
        },

        updateEmployeeSalaryValidation() {
            this.formSubmitted = true;

            if(this.isUpdateSalaryValid()){
                this.updateSalaryEmployee(this.form);
            }
        },

        updateEmployeeInformationValidation() {
            this.formSubmitted = true;

            if(this.isUpdateInformationValid()){
                this.updateGeneralEmployee(this.form); return;
            }
        },

        isUpdateGeneralValid(){
            this.valid = true;

            this.clearErrors();
            
            if(this.form.name.length == 0){
                this.errors.name = "El nombre es obligatorio."
                this.valid = false;
            }

            if(this.form.zipcode.length == 0){
                this.errors.rfc = "El código postal es obligatorio."
                this.valid = false;
            }

            return this.valid;
        },

        isUpdateContractValid(){
            this.valid = true;

            this.clearErrors();
            
            if(!(this.form.employee_position_id > 0)){
                this.errors.employee_position_id = "El puesto es obligatorio."
                this.valid = false;
            }

            if(this.form.final_wage > 8000){
                this.errors.final_wage = "El sueldo quincenal no debe ser mayor a 8,000."
                this.valid = false;
            }

            if(this.form.bono_amount > 2000){
                this.errors.bono_amount = "El bono no debe ser mayor a 2,000."
                this.valid = false;
            }

            return this.valid;
        },

        isUpdateSalaryValid(){
            this.valid = true;

            this.clearErrors();
            
            if(this.form.rfc.length == 0){
                this.errors.rfc = "El RFC es obligatorio."
                this.valid = false;
            }

            if(this.form.curp.length == 0){
                this.errors.curp = "La CURP es obligatorio."
                this.valid = false;
            }

            if(this.form.nss.length == 0){
                this.errors.nss = "El NSS es obligatorio."
                this.valid = false;
            }

            if(this.form.net_fiscal > 5000){
                this.errors.net_fiscal = "El sueldo fiscal no debe ser mayor a 5,000."
                this.errors.daily_salary = "El salario diario debe ser menor."
                this.valid = false;
            }

            return this.valid;
        },

        isUpdateInformationValid(){
            this.valid = true;

            this.clearErrors();
            
            if(this.form.rfc.length == 0){
                this.errors.rfc = "El RFC es obligatorio."
                this.valid = false;
            }

            if(this.form.curp.length == 0){
                this.errors.curp = "El CURP es obligatorio."
                this.valid = false;
            }

            if(this.form.nss.length == 0){
                this.errors.nss = "El NSS es obligatorio."
                this.valid = false;
            }

            if(this.form.zipcode.length == 0){
                this.errors.zipcode = "El código postal es obligatorio."
                this.valid = false;
            }

            if(this.form.email == undefined || this.form.email.length == 0){
                this.errors.email = "El correo electrónico es obligatorio."
                this.valid = false;
            }

            if(this.form.phone.length == 0){
                this.errors.phone = "El teléfono es obligatorio."
                this.valid = false;
            }

            return this.valid;
        },

        updateEmployeeValidation() {
            this.formSubmitted = true;
            
            if(this.isUpdateValid()){
                this.updateEmployee(this.form);
            }
        },

        isUpdateValid(){
            this.valid = true;

            this.clearErrors();

            return this.valid;
        },
        disableEmployeeValidation() {
            this.formSubmitted = true;
            
            if(this.isDisableValid()){
                this.disableEmployee(this.form);
            }
        },
        isDisableValid(){
            this.valid = true;

            this.clearErrors();

            if(this.form.final_date == undefined){
                this.errors.final_date = "La fecha de salida es obligatoria."
                this.valid = false;
            }

            if(this.form.observations.length == 0){
                this.errors.observations = "Las observaciones para la baja son obligatorias."
                this.valid = false;
            }

            return this.valid;
        },
        updateEmployeeInfonavitValidation() {
            this.formSubmitted = true;
            
            if(this.isUpdateInfonavitValid()){
                this.storeEmployeeInfonavit(this.form);
            }
        },
        isUpdateInfonavitValid(){
            this.valid = true;

            this.clearErrors();
            
            if(this.form.infonavit.length == 0){
                this.errors.infonavit = "El infonavit es un cambio obligatorio (puede ser 0.00)."
                this.valid = false;
            }
            
            return this.valid;
        },
        updateEmployeeFonacotValidation() {
            this.formSubmitted = true;
            
            if(this.isUpdateFonacotValid()){
                this.storeEmployeeFonacot(this.form);
            }
        },
        isUpdateFonacotValid(){
            this.valid = true;

            this.clearErrors();
            
            if(this.form.fonacot.length == 0){
                this.errors.fonacot = "El fonacot es un cambio obligatorio (puede ser 0.00)."
                this.valid = false;
            }
            
            return this.valid;
        },
        updateEmployeeBonoValidation() {
            this.formSubmitted = true;
            
            if(this.isUpdateBonoValid()){
                this.storeEmployeeBono(this.form);
            }
        },
        isUpdateBonoValid(){
            this.valid = true;

            this.clearErrors();
            
            if(this.form.bono_amount.length == 0){
                this.errors.fonacot = "El bono es un cambio obligatorio (puede ser 0.00)."
                this.valid = false;
            }
            
            return this.valid;
        },
        sendContractEmployeeValidation() {
            this.formSubmitted = true;
            
            if(this.isSendEmployeeValid()){
                this.sendContractEmployee(this.form);
            }
        },
        isSendEmployeeValid(){
            this.valid = true;

            this.clearErrors();
            
            if(this.form.email.length == 0){
                this.errors.email = "El correo electrónico es un cambio obligatorio."
                this.valid = false;
            }
            
            return this.valid;
        },
    }
}